import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import { ProdutoTipo } from "../types/ProdutoTipo";

export async function getProdutosTipo(search? : number) {
  let response = await api
    .get(`${URLS.PRODUTOS_TIPO_API}`)
    .then((resp) => resp.data);
  
  search && response?.filter((item : any) => {
    return item.ProdutoTipoId === search
  })

  return response.map((tipo: ProdutoTipo) => ({
    Key: tipo.ProdutoTipoId,
    ProdutoTipoId: tipo.ProdutoTipoId,
    Nome: tipo.Nome
  }));
}